import React, { Component, PropTypes } from 'react';
import {
    ReactSparkTextArea,
    ReactSparkToggle,
    ReactSparkSelectInput,
    ReactSparkTextInput
} from '../../../widgets/index';
import InputTextField from 'components/common/InputTextField';
import { SANITIZATION_TYPES } from '../../../common/sanitizationTypes';

class AddContentPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            themelevel: this.props.selected,
            hotel: this.props.hotel,
            baseTheme: this.props.baseTheme,
            name: this.props.name,
            code: this.props.code,
            updated: this.props.updated,
            comments: '',
            themeCode: '',
            selectedTheme: '',
            status: false,
            isDefault: false
        };
    }

    render() {
        return (
            <div className="col-xs-12">
                <h3>Add a Video to a Room Code</h3>
                <div id="add-theme-level" className="row">
                    {/* <div className="col-xs-12">
            <h4 className="pull-left">Select Theme Level</h4>
            <ReactSparkToggle name="add-theme-toggle" onChange={ev => this.setState({...this.state, themelevel: ev.target.value})} key={this.props.selected}
                              values={[{key: "chain", label: "Chain"}, {
                                key: "brand",
                                label: "Brand"
                              }, {key: "hotel", label: "Hotel"}]}
                              selected={this.props.selected}/>
            <ReactSparkSelectInput label="Select Hotel" values={this.props.hotels}/>
          </div> */}
                    {/* <div id="add-theme-select-theme" className="col-xs-12">
            <h4 className="pull-left">Select Theme</h4>
          </div> */}
                    <div id="add-theme-name-theme" className="col-xs-12">
                        <h4 className="pull-left">Save as</h4>
                        <InputTextField
                            name="theme-name"
                            sparkInputProps={{ label: 'Theme name' }}
                            placeholder="`Theme name"
                            onBlur={this.props.setName}
                        />
                        {/* <ReactSparkTextInput name="theme-name" label="Theme name" placeholder="Theme name" onBlur={(event) => {
                this.props.setName(event.target.value)/> */}
                        <InputTextField
                            name="theme-code"
                            sparkInputProps={{ label: 'Video code' }}
                            placeholder="Video code"
                            disabled={this.props.isDisabled}
                            value={this.state.code}
                            onChange={this.props.setCode}
                        />
                        {/*<ReactSparkTextInput name="theme-code" label="Video code" placeholder="Video code" isDisabled={this.props.isDisabled} value={this.state.code} onChange={(event) => {
                this.props.setCode(event.target.value)
            }}/>*/}
                    </div>
                    <br />
                    <div id="add-theme-comment" className="col-xs-12">
                        <InputTextField
                            name="add-theme-commentbox"
                            sparkInputProps={{ label: 'URL' }}
                            placeholder="URL"
                            disabled={this.props.isDisabled}
                            value={this.state.comments}
                            sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                            replaceInValue={{ '<': '&lt;', '>': '&gt;' }}
                            onChange={this.props.setComments}
                        />
                        {/*<ReactSparkTextInput label="URL" placeholder="URL" name="add-theme-commentbox" isDisabled={this.props.isDisabled} value={this.state.comments} onChange={(event) => {
                this.props.setComments(event.target.value)
            }} softMaxLength={1000}/>*/}
                    </div>
                </div>
            </div>
        );
    }
}

AddContentPanel.propTypes = {
    selected: PropTypes.string,
    population: PropTypes.array,
    dispatchValue: PropTypes.func,
    hotels: PropTypes.array,
    availableThemes: PropTypes.array
};

export default AddContentPanel;



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/AddContentPanel.js